import React, { Component } from 'react';
import LoadingSpinner from './components/LoadingSpinner';
import Overview from './components/Overview';
import ScenarioList from './ScenarioManagement/ScenariosList';
import { getEnvironmentShort } from '../../util/helpers';
import ScenarioZones from './ScenarioManagement/ScenarioZones';
import NoRecordsFound from "./components/NoRecordsFound";

class ScenarioManagement extends Component {
    overviewList = () => {
        let overviewList = {};
        const { selectedScenario } = this.props.loadData;
        const { environment, email, apiKey, customerApiKey, accountId, projectId, zones, deviceDPH, type } = selectedScenario;

        overviewList.email = email;
        overviewList['Api Key'] = apiKey;
        overviewList['Customer Api Key'] = customerApiKey;
        overviewList.environment = getEnvironmentShort(environment);
        overviewList['Number Of Zones'] = zones ? zones.length: 0;
        overviewList['Account Id'] = accountId;
        overviewList['Project Id'] = projectId;
        overviewList['Device DPH'] = !isNaN(deviceDPH) ? deviceDPH + "%" : "N/A";
        overviewList['Type'] = type?type:"field"

        return overviewList;
    };

    render() {
        const {
            loadData,
            handleEditScenarioComments,
            selectScenario,
            deleteScenario,
            updateSortState,
            navigator
        } = this.props;

        let { scenarios, selectedScenario, sort, sortAsc, isLoading } = loadData;
        const { zones } = selectedScenario;

        return (
            <div>
                <ol className="breadcrumb">
                    <li className="active">Scenario Management</li>
                </ol>

                <div className="scenario-management-main-div pull-left">
                    <div className="search-scenario-list">
                        <div className="row">
                            <div className="col-sm-4">
                                <span className="block-heading">
                                    <span className="glyphicon glyphicon-picture" /> Scenarios
                                </span>
                            </div>
                            <div className="col-sm-4">
                                <button
                                    type="button"
                                    className="btn btn-add pull-right"
                                    onClick={navigator.requestAddNewScenario}
                                >
                                    <span className="glyphicon glyphicon-plus" />
                                    New
                                </button>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="search"
                                    placeholder="Search..."
                                    className="form-control scenarios-search"
                                    onChange={this.props.updateSearchState}
                                    value={loadData.search}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="scenarios-list">
                        <div className="table table-striped" id="table-scenario-list">
                            <div id="scenario-list-main-table">
                                {isLoading ? (
                                    <div className="flex-center">
                                        <LoadingSpinner />
                                    </div>
                                ) : (
                                    <ScenarioList
                                        scenarios={scenarios}
                                        selectedScenario={selectedScenario}
                                        sortBy={sort}
                                        isSortAsc={sortAsc}
                                        onSortBy={updateSortState}
                                        onClick={selectScenario}
                                        onEdit={navigator.requestEditScenario}
                                        onDelete={deleteScenario}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="scenario-overview">
                    <Overview
                        name={selectedScenario.name}
                        overviewList={this.overviewList()}
                        updateComments={handleEditScenarioComments}
                        comments={selectedScenario.comments}
                    />
                </div>

                {zones && zones.length ?
                    < ScenarioZones zones={zones} />
                    : <NoRecordsFound message="Please upload Zones to display"/>
                }
            </div>
        ); //return
    } //render
} //ScenarioManagement

export default ScenarioManagement;
